export const NOVEL_COLLECTION = 'NovelCollection'
export const FETCH_NOVEL_COLLECTION = 'FETCH_NOVEL_COLLECTION'
export const RESET_NOVEL_COLLECTION = 'RESET_NOVEL_COLLECTION'
